import { render, staticRenderFns } from "./DescricoesTable.vue?vue&type=template&id=e4ba2318&"
import script from "./DescricoesTable.vue?vue&type=script&lang=js&"
export * from "./DescricoesTable.vue?vue&type=script&lang=js&"
import style0 from "./DescricoesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports